import { Box, Typography, Button } from '@mui/material';
import { ProgressCircle, CourseCard, CourseImage, ImageWrapper, TagBox } from "./ResumeCourseStyle.tsx";
import { Link } from 'react-router-dom';
import './styles.css'
import { RESUME_LEARNING_STRINGS } from '../../components/ResumeLearing/ResumeLearningConstants.js';
import { useTranslation } from 'react-i18next';

const PickUpLearning = ({ cousedata }) => {

  const courseValues = Object.values(cousedata)[0]
  const { t } = useTranslation();
  return (
    <Box width={'100%'} mb={'20px'} >
      <CourseCard>     
        <ImageWrapper>
          <CourseImage src="../../images/courses/c1s.jpeg" alt="Course Thumbnail" />
          <TagBox>{t(RESUME_LEARNING_STRINGS?.TAG_TEXT)}</TagBox>
        </ImageWrapper>   
        <Box className={'courseCardBox'}>
          <Typography className="courseNameWrap">
            {courseValues?.course_name}
          </Typography>

          <Button variant="contained" className="resume-button">
            <Link to={`/courses/${courseValues?.course_id}/course`} className={"error-page-btn-link w-inline-block"}>
              {t(RESUME_LEARNING_STRINGS?.BUTTON_TEXT)}
            </Link>
          </Button>
        </Box>

        <ProgressCircle progress={courseValues?.completion_percentage || 0} />
      </CourseCard>
    </Box>
  );
};

export default PickUpLearning;